import React from 'react';
import { Grid, Row, Col, Panel } from 'react-bootstrap';
import { formatDate, formatDateTime } from '../../../../shared/utils/date';
import SeverityLabel from '../../../../components/SeverityLabel/SeverityLabel';

const isDangerousDelay = delay => {
    if (delay && delay !== '00:00:00') {
        return 'warning';
    }
};

const RunInfo = ({ run }) => {
    if (!run) {
        return <p className="text-center">Loading run information...</p>;
    }

    return (
        <Panel collapsible defaultExpanded header="Route information">
            <Grid fluid>
                <Row>
                    <Col xs={5} className="row-title" style={{ marginBottom: 5 }}>
                        Route status
                    </Col>
                    <Col>{run.runStatus}</Col>
                </Row>
                <Row>
                    <Col xs={5} className="row-title" style={{ marginBottom: 5 }}>
                        Route - Route date - Run Seq.
                    </Col>
                    <Col>
                        {run.routeCode} - {formatDate(run.runDate)} - {run.runSequence || 'N/A'}
                    </Col>
                </Row>
                <Row>
                    <Col xs={5} className="row-title" style={{ marginBottom: 5 }}>
                        Logistic partner
                    </Col>
                    <Col>{run.logisticPartner}</Col>
                </Row>
                <Row>
                    <Col xs={5} className="row-title" style={{ marginBottom: 5 }}>
                        Last received tracking data
                    </Col>
                    <Col>
                        {run.lastGpsLocation
                            ? formatDateTime(run.lastGpsLocation.timestamp)
                            : 'N/A'}
                    </Col>
                </Row>
                <Row>
                    <Col xs={5} className="row-title" style={{ marginBottom: 5 }}>
                        Final logistics point
                    </Col>
                    <Col>{run.finalLogisticsPoint}</Col>
                </Row>
                <Row>
                    <Col xs={5} className="row-title" style={{ marginBottom: 5 }}>
                        Delay
                    </Col>
                    <Col className={isDangerousDelay(run.delay)}>
                        {run.delay ? run.delay : 'None'}
                    </Col>
                </Row>
                <Row>
                    <Col xs={5} className="row-title">
                        Severity
                    </Col>
                    <Col>
                        {run.delaySeverity ? <SeverityLabel code={run.delaySeverity} /> : 'None'}
                    </Col>
                </Row>
            </Grid>
        </Panel>
    );
};

export default RunInfo;
